

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"nonzero","d":"M9.75 0c.41 0 .75.34.75.75s-.34.75-.75.75h-2C3.14 1.5 1.5 3.14 1.5 7.75v6C1.5 18.36 3.14 20 7.75 20h6c4.61 0 6.25-1.64 6.25-6.25v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 5.43-2.32 7.75-7.75 7.75h-6C2.32 21.5 0 19.18 0 13.75v-6C0 2.32 2.32 0 7.75 0h2Zm11 0c.41 0 .75.34.75.75v4.8c0 .41-.34.75-.75.75S20 5.96 20 5.55l-.001-2.991-7.72 7.721c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l7.719-7.72h-2.989c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.8Z"}, []), "\n"]);
};

        